import { onStudentLinkStorageUpdate } from '@/utils/onStudentLinkStorageUpdate'
import { ExtensionController } from '@/utils/ExtensionController'
import { LEARNICS_EXTENSION_IDS } from '@learnics/models/src/ExtensionInstallation/utils/extensionIds.mjs'

const result = {}

const distributionTypes = Object.keys(LEARNICS_EXTENSION_IDS)

for (const distributionType of distributionTypes) {
  result[distributionType] = {}
  const deploymentTypes = Object.keys(LEARNICS_EXTENSION_IDS[distributionType])
  for (const deploymentType of deploymentTypes) {
    result[distributionType][deploymentType] = new ExtensionController(
      distributionType,
      deploymentType,
    )

    if (distributionType === 'oneClick' || distributionType === 'studentLink') {
      result[distributionType][deploymentType].addStorageChangedListener(
        onStudentLinkStorageUpdate,
      )
    }
  }
}
export const extensionControllers = result

export function getAllExtensionControllers() {
  return Object.values(extensionControllers).flatMap((deployment) =>
    Object.values(deployment),
  )
}

export function getSomeActiveExtensionController(
  distributionTypes = ['studentLink', 'oneClick', 'classroomPro'],
  deploymentTypes = ['prod', 'staging'],
) {
  return getAllExtensionControllers().find(
    (c) =>
      c.manifest &&
      distributionTypes.includes(c.distributionType) &&
      deploymentTypes.includes(c.deploymentType),
  )
}

export function getExtensionControllerById(extensionId) {
  return getAllExtensionControllers().find((c) => c.extensionId === extensionId)
}

export async function sendMessageToExtension(distributionType, data) {
  const activeController =
    getActiveExtensionControllerForDistribution(distributionType)
  if (!activeController) {
    console.warn(
      'No active controller found for distribution:',
      distributionType,
    )
    return null
  }
  return await activeController.sendMessage(data)
}

export function getActiveExtensionControllerForDistribution(
  distributionType = 'studentLink',
) {
  const dist = extensionControllers[distributionType]
  if (!dist) {
    throw new Error(`Distribution ID ${distributionType} not found.`)
  }
  const keys = ['prod', 'staging']
  for (const key of keys) {
    if (dist[key]?.manifest) {
      return dist[key]
    }
  }
  return null
}

export async function broadcastMessage(data, filter = (controller) => true) {
  let resp
  try {
    const controllers = getAllExtensionControllers().filter(
      (controller) => !!controller.manifest && filter(controller),
    )

    resp = await Promise.allSettled(controllers.map((c) => c.sendMessage(data)))
  } catch (error) {
    console.log('Error broadcasting message:', error)
  }
  return resp
}

export async function broadcastMessageUntilResponse(
  data,
  filter = (controller) => true,
) {
  const controllers = getAllExtensionControllers().filter(
    (c) => !!c.manifest && filter(c),
  )
  for (let controller of controllers) {
    try {
      let resp = await controller.sendMessage(data)
      return resp
    } catch (error) {
      console.log('Error broadcasting message:', error)
    }
  }
  return null
}
